import { IUserStatusService } from '@typings/user-status';

export const GET_USER_STATUS_CREDIT_BALANCE_KEY = 'GET_USER_STATUS_CREDIT_BALANCE_KEY';

export type GetUserStatusCreditBalanceResultType = Pick<
  IUserStatusService,
  'actualBalance' | 'availableBalance'
>;
